enum PlanActionType {
	GET_PLAN_LIST_REQUEST = "GET_PLAN_LIST_REQUEST",
	GET_PLAN_LIST_SUCCEEDED = "GET_PLAN_LIST_SUCCEEDED",
	GET_PLAN_LIST_FAILED = "GET_PLAN_LIST_FAILED",
}

export default PlanActionType
